import { render, staticRenderFns } from "./beneficiosEditar.vue?vue&type=template&id=e5fe3fc2&scoped=true&"
import script from "./beneficiosEditar.vue?vue&type=script&lang=js&"
export * from "./beneficiosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe3fc2",
  null
  
)

export default component.exports